var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"c-header-secondary__item c-header-secondary__item--fill u-pv--\"><div class=\"c-header-filter\"><div ng-show=\"vm.disabled\" class=\"c-header-placeholder\"><b class=\"c-header__heading-small\">No Filter</b></div><div ng-show=\"!vm.disabled\" class=\"c-header-placeholder\"><b class=\"c-header__heading-small\">Filter</b><a ng-repeat=\"(key, value) in vm.searchParams\" class=\"o-btn c-btn c-btn--dashed c-btn--filter u-ml--\"><span gg-icon=\"icon-close\" ng-click=\"vm.removeFilter(key)\" class=\"c-btn--filter__icon\"></span>{{ key | translate }}: {{ value | translateCountry:key }}</a><a gg-icon=\"icon-plus\" inner-text=\"{{ 'add' | translate }} {{ 'more' | translate }} {{ 'filters' | translate }} \" ng-click=\"vm.openFilterWidget()\" class=\"o-btn c-btn c-btn--secondary c-btn--secondary__header c-btn--small js-filters-widget-open u-ml--\"></a></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/filter/filterHeader.jade
 ** module id = 590
 ** module chunks = 0
 **/